import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import { TestimoniosCarrusel } from '../../UI/TestimoniosCarrusel';
import styles from './Ubicacion.module.css';

export const LocationSection = () => {
  const [ref, visible] = useScrollAnimation({ threshold: 0.06 });

  return (
    <section id="location" ref={ref} className={`${styles.seccion} ${visible ? styles.visible : ''}`}>
      <div className={styles.grid}>

        {/* ── Left: Map ── */}
        <div className={`${styles.columnasMapa} ${visible ? styles.mapaVisible : ''}`}>
          <div className={styles.mapaMarco}>
            <iframe
              title="Ubicación SEIMA"
              src="https://maps.google.com/maps?q=SEIMA+Blvd+los+Proceres+19-08+Ciudad+de+Guatemala+Guatemala&z=16&output=embed&hl=es"
              className={styles.mapa}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            href="https://maps.app.goo.gl/jS5Ee7Rq1hyc5yiz5"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.mapaLink}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="13" height="13">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
            Abrir en Google Maps
          </a>
        </div>

        {/* ── Right: Info ── */}
        <div className={styles.columnaInfo}>

          {/* Title — same word-by-word animation as Historia */}
          <h2 className={styles.titulo}>
            {['Dónde', 'Encontrarnos'].map((palabra, i) => (
              <span
                key={i}
                className={`${styles.palabraWrap} ${visible ? styles.palabraVisible : ''}`}
                style={{ transitionDelay: `${i * 140}ms` }}
              >
                {i === 1 ? <span className={styles.acento}>{palabra}</span> : palabra}
              </span>
            ))}
          </h2>
          <div className={`${styles.lineaTitulo} ${visible ? styles.lineaVisible : ''}`} />

          {/* Address */}
          <div className={styles.direccion}>
            <span className={styles.direccionIcono}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="18" height="18">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
              </svg>
            </span>
            <div>
              <p className={styles.direccionLinea1}>Blvd. los Próceres 19-08</p>
              <p className={styles.direccionLinea2}>Ciudad de Guatemala, Guatemala 01010</p>
            </div>
          </div>

          <p className={styles.descripcion}>
            Desde nuestra sede en Ciudad de Guatemala, SEIMA opera como el proveedor industrial
            de referencia para lavanderías comerciales, hospitalarias y hoteleras, con respuesta
            técnica inmediata en todo el territorio nacional.
          </p>

          {/* Simplified coverage */}
          <div className={styles.coberturaBloque}>
            <span className={styles.coberturaTitulo}>Cobertura</span>
            <div className={`${styles.coberturaPais} ${visible ? styles.coberturaVisible : ''}`}>
              <img src="/imagenes/banderas/gt.webp" alt="Guatemala" className={styles.coberturaBandera} />
              <div>
                <p className={styles.coberturaNombre}>Guatemala</p>
                <p className={styles.coberturaRol}>Sede Central · Cobertura Nacional</p>
              </div>
            </div>
            <p className={`${styles.coberturaTexto} ${visible ? styles.coberturaTextoVisible : ''}`}>
              A lo largo de su trayectoria, SEIMA ha realizado proyectos en países como
              El Salvador y Honduras, consolidando su reputación como referente industrial
              en la región centroamericana.
            </p>
          </div>

        </div>
      </div>

      <div className="container" style={{ paddingBottom: '72px' }}>
        <TestimoniosCarrusel />
      </div>
    </section>
  );
};
export default LocationSection;
